module.exports = __webpack_public_path__ + "b6f338a6890232159c4bf0dfa8f67cca.svg";